import type { MailboxInfo } from 'owa-client-types';
import { getAccountKeyForMailboxInfo } from 'owa-client-types';
import { getItem, itemExists, type LocalStorageKeys } from 'owa-local-storage';
import type { CopilotExperimentStorageKey } from './copilotExperimentKeys';

export function getCopilotExperimentFromLocalStorage(
    experimentKey: CopilotExperimentStorageKey,
    mailboxInfo: MailboxInfo
): Map<string, string> {
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
    const localStorageKey: LocalStorageKeys = `mail_copilot_experiment_${experimentKey}_${accountKey}`;

    try {
        if (itemExists(window, localStorageKey)) {
            return new Map(Object.entries(JSON.parse(getItem(window, localStorageKey) as string)));
        }
    } catch {
        return new Map();
    }

    return new Map();
}
